<template>
  <div class="d-flex align-center">
    <template
      v-if="
        $constants.situacoesMatriculaCondition[
          removerEspaco(matricula.situacao ? matricula.situacao : '')
        ]
      "
    >
      <v-currency-field
        locale="en-US"
        :default-value="null"
        :value="value"
        hide-details
        :allow-negative="false"
        dense
        :min="min"
        :decimal-length="1"
        :max="max"
        ref="input"
        v-bind="{ outlined: true }"
        v-bind:style="{
          'min-width': '60px !important',
          'max-width': '60px !important',
        }"
        :disabled="true"
      />
    </template>
    <template v-else-if="tipoValor === 'valor_texto'">
      <!-- {{ notaTexto.valores_texto }} -->
      <v-select
        v-if="notaTexto"
        @change="verificarVal($event)"
        :items="optionsNotaTexto"
        :item-value="(value) => value.descricao"
        :item-text="(value) => value.descricao"
        :value="notaTexto.valor_texto"
        label="Selecione um tipo"
        outlined
      ></v-select>
      <v-select
        v-else-if="valorSelect"
        @change="verificarVal($event)"
        :items="optionsNotaTexto"
        :item-value="(value) => value.descricao"
        :item-text="(value) => value.descricao"
        :value="valorSelect"
        label="Selecione um tipo"
        outlined
      ></v-select>
      <v-select
        v-else
        @change="verificarVal($event)"
        :items="optionsNotaTexto"
        :item-value="(value) => value.descricao"
        :item-text="(value) => value.descricao"
        label="Selecione um tipo"
        outlined
      ></v-select>
    </template>
    <template v-else>
      <v-currency-field
        :key="campoKey"
        locale="en-US"
        :default-value="null"
        @input="(val) => handleInput(val)"
        @blur="handleBlur"
        :value="valorLocal !== null ? valorLocal : value ? value : null"
        hide-details
        :allow-negative="false"
        dense
        :min="min"
        :max="max"
        :decimal-length="1"
        ref="input"
        v-bind="{ outlined: true }"
        v-bind:style="{ 'min-width': '60px !important', 'max-width': '60px !important' }"
        :disabled="disabled"
      />
      <!-- :maxlength="2" -->
      <v-btn
        icon
        small
        v-show="value === null && value !== undefined && !disabled"
        color="error"
        class="red lighten-5 ml-2"
        @click="emitNull"
      >
        <v-icon x-small>fa fa-close</v-icon>
      </v-btn>
    </template>
    <e-modal-info
      @closeModal="showModal = false"
      :dadosModal="dadosModal"
      :showModal="showModal"
    ></e-modal-info>
  </div>
</template>
<script>
import EModalInfo from "./EModalInfo.vue";

export default {
  components: {
    EModalInfo,
  },
  props: {
    value: {
      type: [String, Number],
    },
    tipoValor: {
      type: [String],
    },
    circuitoId: {
      type: Number,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
    valMax: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    matricula: {
      type: Object,
      required: true,
    },
    notaTexto: {
      type: Object,
      required: false,
    },
    notaTextoLetra: {
      type: String,
    },
    etapaAtual: {
      type: Number,
    },
    arredondamento: {
      type: [Number, Boolean],
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.arredondamento && val !== null && val !== undefined && val !== 0 && val !== "" && !isNaN(parseFloat(val))) {
          this.valorLocal = this.arredondar(val);
        }
      },
    },
    etapaAtual(value) {
      if (this.notaTextoLetra) {
        this.valorSelect = this.notaTextoLetra;
      } else {
        this.valorSelect = value;
      }
    },
    valMax(val) {
      // console.log("mudou valor maximo", val);
    },
  },
  data() {
    return {
      optionsNotaTexto: [],
      valorSelect: null,
      currentVal: null,
      valorLocal: null,
      campoKey: 0,
      dadosModal: {
        titulo: null,
        mensagem1: null,
        mensagem2: null,
        botao: null,
      },
      showModal: false,
    };
  },
  mounted() {
    this.getOptionsSelect();
  },
  methods: {
    exibirModal(maximo) {
      this.dadosModal = {
        titulo: `Ops! O valor digitado é muito alto`,
        mensagem1: `Insira um valor igual ou abaixo de ${maximo}.`,
        botao: "Ok",
      };
      this.showModal = true;
    },
    verificarVal($event) {
      this.$emit("add", $event);
    },
    async getOptionsSelect() {
      const circuito = await this.$services.circuitoNotasService.getCircuito(this.circuitoId);
      this.optionsNotaTexto = circuito.valores_notas_texto;
    },
    arredondar(val) {
      const num = parseFloat(val);
      const decimalPart = num % 1;
      if (decimalPart > 0 && decimalPart < 0.5) return Math.floor(num) + 0.5;
      if (decimalPart > 0.5) return Math.ceil(num);
      return num;
    },
    emitVal(val) {
      if (val === 0) {
        this.$emit("input", val);
        this.$emit("change", val);
      } else if (val > this.valMax) {
        this.$emit("anularValor");
        this.exibirModal(this.valMax);
      } else if (val < this.min) {
        this.$refs.input.$emit("input", this.min);
      } else {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },
    handleInput(val) {
      if (this._arredondando) return;
      this.currentVal = val;
      if (val > this.valMax) {
        this.$emit("anularValor");
        this.exibirModal(this.valMax);
        return;
      }
      if (!this.arredondamento) {
        this.emitVal(parseFloat(val));
      }
    },
    handleBlur() {
      if (this.arredondamento && this.currentVal !== null && this.currentVal !== undefined) {
        const arredondado = this.arredondar(this.currentVal);
        this.valorLocal = arredondado;
        this.campoKey++;
        this.emitVal(this.currentVal);
      }
    },
    emitNull() {
      // this.$emit("input", undefined);
      // this.$emit("change", undefined);
      setTimeout(() => {
        // eslint-disable-next-line
        this.$refs.input._data.formattedValue = "";
      }, 150);
    },
    removerEspaco(string) {
      // return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },
  },
};
</script>
